// Author: T4professor

import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-button3-renderer',
  template: `
    <img width="18px" id="view" style="cursor:pointer;" (click)="onClick($event)" title="View" src="../../../../assets/images/View-icon.png" />
    <img width="18px" id="addcomment" style="cursor:pointer;margin-left: 3px;" (click)="onClick($event)" title="Add Comments" src="../../../../assets/images/comment.png" />
    <img width="18px" id="projectinfo" style="cursor:pointer;margin-left: 3px;background-color: #8bd154;" (click)="onClick($event)" title="Project Information" src="../../../../assets/images/assignsrvy_ico.png" />
    <img width="18px" id="projectlog" style="cursor:pointer;margin-left: 3px;" (click)="onClick($event)" title="Project Log" src="../../../../assets/images/log-ico.png" />
    `
})

export class Button3RendererComponent implements ICellRendererAngularComp {

  params;
  label: string;

  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    return true;
  }

  onClick($event) {
    debugger;
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      this.params.onClick(params);

    }
  }
}
